import React, { useEffect, useRef, useState } from 'react'
import { BsChevronLeft, BsClipboardPlus } from 'react-icons/bs'
import SideNav from '../../Components/SideNav'
import styles from "./Styles/Records.module.css"
import common from "./Styles/Common.module.css"
import CustomDropdown from "../../Components/CustomDropdown"
import Button from "../../Components/Button"
import { HiOutlineDocumentText, HiOutlineUsers } from 'react-icons/hi'
import {TbClipboardText} from "react-icons/tb"
import { FiEdit } from 'react-icons/fi'
import {RiAttachmentLine, RiDeleteBin6Line, RiSendPlaneFill} from "react-icons/ri"
import {GrAttachment} from "react-icons/gr"
import { useNavigate } from 'react-router-dom'

export default function Records() {
  const [selectedTab, setSelectedTab] = useState('Activity')
  const navigate = useNavigate()

  const Activity = () => {
    return <div className={styles.activity}>
        <div className={styles.card}>
            <div className={styles.activityHeader}>
                <div>
                <p>Activity Type</p>
                <CustomDropdown white options={['option']} value="Marketing" />
                </div>
                <div>
                <p>Activity Time</p>
                <CustomDropdown white options={['option']} value="Last 3 months" />
                </div>
                <Button title="Add" bgColor="#299EFE" />
            </div>

            {Array(3).fill('').map(i => {
                return <div className={styles.activityContent}>
                <h2>SEP 2022</h2>
                <div className={styles.activityContentListItem}>
                    <div className={styles.icon}>
                        <HiOutlineDocumentText size={24} color="#707070" />
                    </div>
                    <div>
                        <h3>Sep 23</h3>
                        <h4>20:14 PM</h4>
                    </div>
                    <div className={styles.separator} />
                    <div>
                        <h5>Lead status changed from Query to lost by Sakshi</h5>
                    </div>
                </div>
                <div className={styles.activityContentListItem}>
                    <div className={styles.icon}>
                        <HiOutlineDocumentText size={24} color="#707070" />
                    </div>
                    <div>
                        <h3>Sep 23</h3>
                        <h4>20:14 PM</h4>
                    </div>
                    <div className={styles.separator} />
                    <div>
                        <h5>Lead Owner changed from Admin to Sakshi by System through Autotomation</h5>
                    </div>
                </div>
            </div>
            })}

        </div>
    </div>
  }

  const Notes = () => {
    const [notes, setNotes] = useState(['asd'])
    return <div className={styles.notes}>
        {notes.length == 0 ? <div className={styles.card}>
            <div className={styles.emptyState}>
                <p>You don’t have any notes yet</p>
                <button>
                    <TbClipboardText color="#299EFE" size={24} />
                    <span>New Note</span>
                </button>
            </div>
        </div> : <div>
            <div className={styles.newBtn}><Button bgColor="#299EFE" mb={8} width={150} title="New Note" /></div>
            <div className={styles.card}>
                {Array(5).fill('').map(i => {
                    return <div style={{backgroundColor:['#FDECEC','#FDFBEC','#ECF1FD','#FDECEC'][Math.floor(Math.random() * (3 - 0 + 1) + 0)]}} className={styles.note}>
                    <main className={styles.noteContent}>
                        <p>bird, (class Aves), any of the more than 10,400 living species unique in having feathers, the major characteristic that distinguishes them from all other animals. A more-elaborate definition would note that they are warm-blooded vertebrates more related to reptiles than to mammals and that they....</p>
                        <div className={styles.noteFooter}>
                            <p>Created By:</p>
                            <span>John Wick</span>
                            <div className={styles.bullet}></div>
                            <span>11 Nov 2022</span>
                            <div className={styles.bullet}></div>
                            <span>14:20 PM</span>
                        </div>
                    </main>
                    <aside>
                        <div className={styles.editDelete}>
                            <FiEdit color="#299EFE" size={22} />
                            <RiDeleteBin6Line color="#F7685B" size={22} />
                        </div>
                        <p className={styles.attachment}>
                            <GrAttachment color="#575757" />
                            Note attachment
                        </p>
                    </aside>
                </div>
                })}  
            </div>   
        </div>}
    </div>
  }


  const Tasks = () => {
    const [tasks, setTasks] = useState(['sdadas'])
    return <div className={styles.tasks}>
        {tasks.length == 0 ? <div className={styles.card}>
            <div className={styles.emptyState}>
                <p>You don’t have any task yet</p>
                <button>
                    <BsClipboardPlus color="#299EFE" size={24} />
                    <span>New Task</span>
                </button>
            </div>
        </div> : <div>
        <div className={styles.newBtn}><Button bgColor="#299EFE" mb={8} width={150} title="Add Task" /></div>
        <div className={styles.card}>
            {Array(4).fill('').map(i => {
                return <div className={styles.task}>
                <main>
                    <p className={styles.taskHeading}>
                      <HiOutlineUsers size={14} color="#a9d7fc" />
                      Meeting
                    </p>
                    <div className={styles.taskDetails}>
                        <div>
                            <div>
                                <h2>Subject</h2>
                                <h3>Layout Planning</h3>
                            </div>
                            <div>
                                <h2>Location</h2>
                                <h3>Gurugram, Haryana</h3>
                            </div>
                        </div>
                        <div>
                            <div>
                                <h2>
                                Schedule
                                </h2>
                                <h3>
                                Nov 23, 2022 | 14:30 PM - 15:30 PM
                                </h3>
                            </div>
                        </div>
                    </div>
                </main>
                <aside>
                        <div className={styles.editDelete}>
                            <FiEdit color="#299EFE" size={22} />
                            <RiDeleteBin6Line color="#F7685B" size={22} />
                        </div>
                        <p className={styles.status}>
                           Upcoming
                        </p>
                </aside>
            </div>
            })}    
        </div>  
        </div>}
    </div>
  }

  const Chat = () => {
     return <div className={styles.chat}>
        <header>
            <img src="https://t4.ftcdn.net/jpg/02/81/89/73/360_F_281897358_3rj9ZBSZHo5s0L1ug7uuIHadSxh9Cc75.jpg" />
            <p>Group Name</p>
        </header>

        <main>
            <div className={styles.user}>
                <p>Sent by You</p>
                <div>
                    Morning Angelie, I have question about My Task
                </div>
                <p>Today 11:52</p>
            </div>

            <div className={styles.other}>
                <p>Sent by Rahul</p>
                <div>Yes sure, Any problem with your assignment?</div>
                <p>Today 11:53</p>
            </div>

            <div className={styles.user}>
                <p>Sent by You</p>
                <div>
                    <img src="https://t4.ftcdn.net/jpg/02/81/89/73/360_F_281897358_3rj9ZBSZHo5s0L1ug7uuIHadSxh9Cc75.jpg" />
                    Morning Angelie, I have question about My Task
                </div>
                <p>Today 11:52</p>
            </div>
        </main>

        <footer>
            <input placeholder="Send your message..." type='text' />
            <div style={{display:'flex',alignItems:'center',gap:20}}>
                <RiAttachmentLine color="#9C9CA4" size={22} />
                <div className={styles.sendBtn}>
                    <RiSendPlaneFill color="#fff" size={22} />
                </div>
            </div>
        </footer>
     </div>
  }

  return (
    <div className={common.container}>
        <div className={common.backIcon}>
            <div onClick={()=>navigate('/dashboard/leads')}>
                <BsChevronLeft size={26} color="#0E1123" />
            </div>
            <p>Back</p>
        </div>

        <main >
            <SideNav />

            <div className={common.main}>
            <div className={styles.tabs}>
                <div className={selectedTab == 'Activity' && styles.activeTab} onClick={()=>setSelectedTab('Activity')}>
                    Activity
                </div>
                <div className={selectedTab == 'Chat' && styles.activeTab} onClick={()=>setSelectedTab('Chat')}>
                    Chat
                </div>
                <div className={selectedTab == 'Tasks' && styles.activeTab} onClick={()=>setSelectedTab('Tasks')}>
                    Tasks
                </div>
                <div className={selectedTab == 'Notes' && styles.activeTab} onClick={()=>setSelectedTab('Notes')}>
                    Notes
                </div>
            </div>

            {selectedTab == 'Activity' && <Activity />}
            {selectedTab == 'Notes' && <Notes />}
            {selectedTab == 'Tasks' && <Tasks />}
            {selectedTab == 'Chat' && <Chat />}
            
            </div>
        </main>
    </div>
  )
}
